import { Flex, Spinner } from "@chakra-ui/react";

export default function LoadingComp() {
  return (
    <Flex w="full" h="full" alignItems="center" justifyContent="center">
      <Spinner w="5rem" h="5rem" />
    </Flex>
  );
}
